{
  "navbar": {
    "logout": "Выход"
  }
}
